import React, { useState, useEffect } from "react";


const mayusculaPrimerLetra = (string) => {
    if (!string) return "";
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
};


const DivsNavBar = ({ screenname, weather }) => {
  const [currentDiv, setCurrentDiv] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentDiv((prev) => (prev === 0 ? 1 : 0));
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="relative w-full overflow-hidden">
      <div
        className={`flex w-full transition-transform duration-1000 ease-in-out ${
          currentDiv === 0 ? "translate-x-0" : "-translate-x-full"
        }`}
        style={{ top: 0 }}
      >
        <div className="text-right font-semibold text-sm px-1">
          <p>Bienvenido</p>
          <p>{screenname}</p>
        </div>
      </div>

      {weather && (
        <div
          className={`absolute w-full transition-transform duration-1000 ease-in-out ${
            currentDiv === 1 ? "translate-x-0" : "translate-x-full"
          }`}
          style={{ top: 0 }}
        >
          <div className="text-sm">
            <p>Clima: 
                <img
                src={`https://openweathermap.org/img/wn/${weather.icon}@2x.png`}
                alt={weather.description}
                className="inline-block w-6 h-6"
                />
                {weather.temperature}°
            </p>
            <p>"{mayusculaPrimerLetra(weather.description)}"</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default DivsNavBar;